import { render, staticRenderFns } from "./extrato-qualificacao-tecnica.vue?vue&type=template&id=2eb8f51a&scoped=true"
import script from "./extrato-qualificacao-tecnica.vue?vue&type=script&lang=js"
export * from "./extrato-qualificacao-tecnica.vue?vue&type=script&lang=js"
import style0 from "./extrato-qualificacao-tecnica.vue?vue&type=style&index=0&id=2eb8f51a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2eb8f51a",
  null
  
)

export default component.exports